<!-- SPDX-License-Identifier: GPL-3.0-or-later -->
<script lang="ts">
  import { Radio, Users } from 'lucide-svelte';
  import type { ConnectionStatus } from '@ffb/shared';
  import IconBadge from '../atoms/IconBadge.svelte';
  import StatusPill from '../molecules/StatusPill.svelte';
  import RoomCopyChip from '../molecules/RoomCopyChip.svelte';

  interface Props {
    roomName: string;
    status: ConnectionStatus;
    peerCount: number;
    copied?: boolean;
    onCopy?: () => void;
  }

  let { roomName, status, peerCount, copied = false, onCopy }: Props = $props();
</script>

<header class="flex items-center justify-between mb-6 gap-3">
  <div class="flex items-center gap-3 min-w-0">
    <IconBadge tone="indigo" size="md">
      <Radio class="w-5 h-5 text-white" />
    </IconBadge>
    <div class="min-w-0">
      <div class="text-white font-bold tracking-tight">ForFridgeBeta</div>
      <RoomCopyChip {roomName} {copied} {onCopy} />
    </div>
  </div>
  <div class="flex items-center gap-2 shrink-0">
    <div
      class="hidden sm:flex items-center gap-1.5 text-xs text-slate-400 bg-white/5 border border-white/10 rounded-full px-3 py-1.5"
    >
      <Users class="w-3.5 h-3.5" />
      <span>{peerCount}</span>
    </div>
    <StatusPill {status} />
  </div>
</header>
